var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"strip-wrap"},[_c('div',{staticStyle:{"width":"100%","height":"800px"},attrs:{"id":"strip"}}),_vm._v(" "),_c('div',{staticClass:"reload",on:{"click":_vm.reload}},[_c('i',{staticClass:"el-icon-refresh-right"}),_vm._v("重播\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a95b246","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/strip.vue
// module id = null
// module chunks = 